import { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { LOGIN_AUTO_EXCEPTION, LOGIN_FAILED } from "../../constants/errMessage";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { checkAccount } from "../../services/authService";
import { useLoading } from "../../utils/spinner";
import { SCREEN_ROUTER } from "../../constants/screenRouter";
import { useNavigate } from "react-router-dom";
import { STORAGE_KEY } from "../../constants/storageKeys";
import { getLocalStorage, removeLocalStorage } from "../../utils/localStorage";
import useIsLoginAccountStore from "../../hooks/useLoginAccount";
import nextScreen from "../../utils/navigateScreen";

const LoginAccount = () => {
    const [inputUsername, setInputUsername] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(""); // Trạng thái để lưu lỗi
    const { setLoading } = useLoading();
    const { isLoginAccount, setIsLoginAccount } = useIsLoginAccountStore()
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (inputUsername == null || inputPassword == '') {
            setIsLoginAccount(false);
            setErrorMessage(LOGIN_FAILED)
            return;
        }
        setLoading(true);
        checkAccount(inputUsername, inputPassword).then((resolve) => {
            if (resolve === true) {
                setIsLoginAccount(true);
                navigate(SCREEN_ROUTER.DASH_BOARD)
            } else if (resolve == -1) {
                // code het han
                removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
                navigate(nextScreen(SCREEN_ROUTER.LOGIN_TOKEN))
            } else {
                setIsLoginAccount(false);
                setErrorMessage(LOGIN_FAILED)
            }
        }).catch((e) => {
            setIsLoginAccount(false);
            setErrorMessage(LOGIN_AUTO_EXCEPTION)
        }).finally(() => {
            setLoading(false);
        })
    };

    useEffect(() => {
        navigate(nextScreen(SCREEN_ROUTER.LOGIN_ACCOUNT))
    }, [])

    return (
        <Container className="mt-3 d-flex justify-content-center">
            <Row className="w-100">
                <Col xs={12} md={6} lg={4} className="mx-auto">
                    <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
                        {/* Header với Tooltip */}
                        <div className="h4 mb-2 text-center d-flex align-items-center justify-content-center">
                            <div className="h4 mb-2 text-center">Đăng nhập</div>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="tooltip-top">Hãy nhập username và password của tài khoản game wjh5.net. Tool chỉ dùng để đăng nhập, không lưu trữ mật khẩu.</Tooltip>}
                            >
                                <span className="ms-2">
                                    <IoIosInformationCircleOutline />
                                </span>
                            </OverlayTrigger>
                        </div>

                        {/* Hiển thị lỗi */}
                        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                        <Form.Group className="mb-2" controlId="username">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                value={inputUsername}
                                placeholder="Username"
                                autoComplete="current-username"
                                onChange={(e) => setInputUsername(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="password">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={inputPassword}
                                autoComplete="current-password"
                                placeholder="Password"
                                onChange={(e) => setInputPassword(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Button className="w-100" variant="primary" type="submit">
                            Log In
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginAccount;
